import { stringify } from 'qs';
import {request} from "../../utils/apiUtils";
import {URL_API} from "../../url.config";

let admin = {
    resetPassword: (payload, callback) => {
        return request({
            url: `${URL_API}/api/one-book-user/secure/one-book/reset-password-user?${stringify(payload)}`,
            method: 'GET'
        }, callback)
    },
}
export default admin
